import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "../../utils/Api";
import Select from "react-select";
import LoadingSplash from "../../globalComponents/LoadingSplash";
import InputField from "../../utils/InputField";
import TextAreaField from "../../utils/TextAreaField";

class OperatorAddContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        changeView: PropTypes.func.isRequired,
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.state = {
            currentCompany: this.props.baseData.companies.currentCompany,
            availableTokenIds: [],
            inputError: [],
            inputParams: {
                operator_name: '',
                operator_info: '',
                id_company: this.props.baseData.companies.currentCompany.id,
                id_token: null,
            },
        };

        this.translate = this.props.baseData.translate;

        this.requestCompaniesForOperator = this.requestCompaniesForOperator.bind(this);
        this.requestAvailableTokenForOperator = this.requestAvailableTokenForOperator.bind(this);
        this.addNewOperator = this.addNewOperator.bind(this);
        this.getInput = this.getInput.bind(this);
        this.editSelect = this.editSelect.bind(this);

    }

    componentWillMount() {

        this.requestCompaniesForOperator();
        this.requestAvailableTokenForOperator();

    }

    requestCompaniesForOperator() {

        const params = {
            action: 'getCompaniesForUser',
            currentCompanyId: this.props.baseData.companies.currentCompany.id,
            companyId: this.props.baseData.companies.currentCompany.id,
            userId: this.props.baseData.userData.id
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    companies: res
                });
            }
        }.bind(this);

        this.api.request('AdminFunctions', params, callback, null);

    }

    requestAvailableTokenForOperator() {

        if (!this.state.inputParams) return null;

        const params = {
            action: 'getCompanyOperatorAvailableTokens',
            currentCompanyId: this.props.baseData.companies.currentCompany.id,
            tokenId: this.state.inputParams.id_token,
            companyId: this.state.currentCompany.id,
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    availableTokenIds: res,
                });
            }
        }.bind(this);

        this.api.request('AdminFunctions', params, callback, null);

    }

    enterSaveAddOperator(event) {

        if (event.keyCode === 13) {
            this.addNewOperator();
        } else if (event.keyCode === 27) {
            this.changeView();
        }

    }

    addNewOperator() {

        const params = {
            action: 'addCompanyOperators',
            currentCompanyId: this.props.baseData.companies.currentCompany.id,
            companyId: parseInt(this.state.inputParams.id_company),
            name: this.state.inputParams.operator_name,
            info: (this.state.inputParams.operator_info) ? this.state.inputParams.operator_info : null,
            newTokenId: this.state.inputParams.id_token,
            oldTokenId: null,
        };

        const callback = function(res) {
            if (res.success) {
                alert(this.translate(res.msgKey));

                this.props.changeView('editView');
            } else {
                this.setInputError(res.errors);
            }
        }.bind(this);

        if (params.name && params.companyId !== null) {
            this.api.request('AdminFunctions', params, callback, null);
        } else {
            if (!params.name) this.setInputError('operator_name');
            if (params.companyId === null) this.setInputError('id_company');
        }

    }

    changeView() {

        if (this.props.changeView) this.props.changeView();

    }

    getInput(event, name, value, isValid) {

        const inputParams = {...this.state.inputParams};

        inputParams[name] = (isValid) ? value : '';

        this.setState({inputParams});

    }

    editSelect(event, key) {

        const inputParams = {...this.state.inputParams};

        inputParams[key] = (event) ? event.value : null;

        this.setState({
            inputParams: inputParams
        });

    }

    getTokenOpt() {

        const availableTokenIds = this.state.availableTokenIds;
        const tokenOpts = [];

        availableTokenIds.forEach(
            (tokenId) => {
                tokenOpts.push({
                    value: tokenId.id_token,
                    label: (tokenId.token_name) ? tokenId.token_name : tokenId.id_token
                });
            }
        );

        tokenOpts.sort((a,b) => {return a.label.localeCompare(b.label);});

        return tokenOpts;

    }

    setInputError(errorFields) {

        this.setState({
            inputError: errorFields,
        });

    }

    resetInputError() {

        this.setState({
            inputError: [],
        });

    }

    checkInputError(fieldName) {

        let result = 'ok';

        if (this.state.inputError) {
            let errorList = this.state.inputError;

            if (errorList.indexOf(fieldName) >= 0) result = 'error';
        }

        return result;

    }

    render() {

        if (!this.state.inputParams) return <LoadingSplash />;

        const tokenOpts = this.getTokenOpt();
        const inputParams = this.state.inputParams;

        const dataCountNote = (this.state.availableTokenIds.length === 0) ? this.translate('noTokenFoundNote') : '';

        return (
            <div className="formSettings">
                <nav>
                    <h1>{this.translate('addNewOperator')}</h1>
                </nav>

                <div className="clearfix">
                    <div className="formRow">
                        <table>
                            <tbody>
                                <tr>
                                    <td className="text-left labelSpan">{this.translate('name')}</td>

                                    <td className="text-left">
                                        <InputField
                                            name="operator_name"
                                            className={this.checkInputError('operator_name')}
                                            value={inputParams.operator_name}
                                            isRequired={true}
                                            onBlur={this.getInput}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td className="text-left labelSpan">{this.translate('info')}</td>

                                    <td className="text-left">
                                        <TextAreaField
                                            name="operator_info"
                                            value={inputParams.operator_info}
                                            onBlur={this.getInput}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td className="text-left labelSpan">{this.translate('token')}</td>

                                    <td className="text-left">
                                        <Select
                                            name="id_token"
                                            className={['chosen-container', 'chosen-container-single', this.checkInputError('id_token')].join(' ').trim()}
                                            style={{width: '260px'}}
                                            options={tokenOpts}
                                            value={tokenOpts.find(o => String(o.value) === String(inputParams.id_token)) || null}
                                            placeholder={this.translate('select') + '...'}
                                            clearable={false}
                                            noResultsText={this.translate('noResultsFound')}
                                            onChange={(event) => this.editSelect(event, 'id_token')}
                                        />
                                    </td>

                                    <td className="optionBar">
                                        <a className="optionClear" onClick={() => this.editSelect(null, 'id_token')} style={{marginLeft: 5}}>&nbsp;</a>
                                    </td>
                                </tr>

                                <tr>
                                    <td className="text-left labelSpan webElement">&nbsp;</td>

                                    <td className="text-left">
                                        <a className="formButton" onClick={() => this.props.changeView('editView')}>
                                            {this.translate('cancel')}
                                        </a>

                                        <a className="formButton" onClick={() => this.addNewOperator()} onKeyDown={(event) => this.enterSaveAddOperator(event)}>
                                            {this.translate('save')}
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div>{dataCountNote}</div>
                </div>
            </div>
        );

    }

}

export default OperatorAddContainer;